import React from "react";
import { observer } from "mobx-react";

const DataSourceComponent = ({ store }) => {
  const handleUpdateDataSource = (event) => {
    const value = event.target.value;
    store.dataSource = value;
  };

  const handleUpdateForeignDataSource = (event, cubeId) => {
    const value = event.target.value;
    store.selectedForeignDataSources[cubeId] = value;
  };

  return (
    <section>
      <h4>Data Source in DEVO:</h4>
      <div className="CubeQueryWizard_data-source-row primary-cube">
        {store.selectedCubeLinks.length +
          store.selectedCubeRelationships.length >
          0 && (
          <label
            htmlFor="data-source"
            title={`${store.cubeDetails[0].name || "Primary Cube"} (${
              store.cubeDetails[0].code
            })`}
          >
            {store.cubeDetails[0].name || "Primary Cube"} (
            {store.cubeDetails[0].code})
          </label>
        )}
        {store.dataSources.length > 0 ? (
          <select
            id="data-source"
            className="form-control"
            onChange={handleUpdateDataSource}
            value={store.dataSource}
          >
            <option value="NO_DATA_SOURCE">- Select data source -</option>
            {store.dataSources.map((databaseTable) => (
              <option
                value={databaseTable.table}
                key={databaseTable.table + " " + databaseTable.source}
                title={databaseTable.source}
              >
                {databaseTable.table}
              </option>
            ))}
          </select>
        ) : (
          <div className="alert alert-warning" role="alert">
            <span
              className="glyphicon glyphicon-info-sign"
              aria-hidden="true"
            ></span>{" "}
            <span className="sr-only">Warning:</span>
            No data sources available. Please, insert manually.
          </div>
        )}
      </div>
      {store.selectedCubeLinks.length + store.selectedCubeRelationships.length >
        0 && <h5 className="foreign-data-sources-heading">Linked Cubes</h5>}
      {store.foreignCubesArray.map((cube) => {
        return (
          <div
            className="CubeQueryWizard_data-source-row"
            key={cube.details.cubeId}
          >
            <label
              htmlFor={`data-source-${cube.details.tid}`}
              title={`${cube.details.name} (${cube.details.code})`}
            >
              {cube.details.name} ({cube.details.code})
            </label>
            {store.foreignCubesDataSources[cube.details.cubeId].length > 0 ? (
              <select
                id={`data-source-${cube.details.tid}`}
                className="form-control"
                onChange={(e) =>
                  handleUpdateForeignDataSource(e, cube.details.cubeId)
                }
                value={store.selectedForeignDataSources[cube.details.cubeId]}
              >
                <option value="NO_DATA_SOURCE">- Select data source -</option>
                {store.foreignCubesDataSources[cube.details.cubeId].map(
                  (databaseTable) => (
                    <option
                      value={databaseTable.table}
                      key={databaseTable.table + " " + databaseTable.source}
                      title={databaseTable.source}
                    >
                      {databaseTable.table}
                    </option>
                  )
                )}
              </select>
            ) : (
              <div className="alert alert-warning" role="alert">
                <span
                  className="glyphicon glyphicon-info-sign"
                  aria-hidden="true"
                ></span>
                <span className="sr-only">Warning:</span>
                No data sources available. Please, insert manually.
              </div>
            )}
          </div>
        );
      })}
    </section>
  );
};

export const DataSource = observer(DataSourceComponent);
